import type { AxiosInstance } from 'axios'
import * as R from 'ramda'

import { CategorySearchResponse } from '../../interfaces/category'

export const searchCategory = (api: AxiosInstance) => async ({
  queryKey
}: {
  queryKey: string[]
}): Promise<CategorySearchResponse[]> => {
  if (R.isEmpty(queryKey[1])) return []
  const { data } = await api.get(`/v1.0/admin/categories/search/${queryKey[1]}`)
  return data
}
